import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/assignment`;

export const ACTION_TYPES = {
  FETCH_ASSIGNMENT_LIST: 'assignment/FETCH_ASSIGNMENT_LIST',
  FETCH_ASSIGNMENT: 'assignment/FETCH_ASSIGNMENT',
  CREATE_ASSIGNMENT: 'assignment/CREATE_ASSIGNMENT',
  UPDATE_ASSIGNMENT: 'assignment/UPDATE_ASSIGNMENT',
  DELETE_ASSIGNMENT: 'assignment/DELETE_ASSIGNMENT',
  RESET: 'assignment/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [], //ent
  entity: {}, //defaultValue
  pageable: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    pageSize: 10,
    pageNumber: 0,
    offset: 0,
    paged: true,
    unpaged: false,
  },
  totalElements: 0,
  last: false,
  totalPages: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  size: 0,
  number: 0,
  empty: true,
};

// REDUCER
const assignmentReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_ASSIGNMENT_LIST):
    case REQUEST(ACTION_TYPES.FETCH_ASSIGNMENT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_ASSIGNMENT):
    case REQUEST(ACTION_TYPES.UPDATE_ASSIGNMENT):
    case REQUEST(ACTION_TYPES.DELETE_ASSIGNMENT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_ASSIGNMENT_LIST):
    case FAILURE(ACTION_TYPES.FETCH_ASSIGNMENT):
    case FAILURE(ACTION_TYPES.CREATE_ASSIGNMENT):
    case FAILURE(ACTION_TYPES.UPDATE_ASSIGNMENT):
    case FAILURE(ACTION_TYPES.DELETE_ASSIGNMENT):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload.response,
      };
    case SUCCESS(ACTION_TYPES.FETCH_ASSIGNMENT_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
        pageable: {
          sort: {
            sorted: res.pageable.sort.sorted,
            unsorted: res.pageable.sort.unsorted,
            empty: res.pageable.sort.empty,
          },
          pageSize: res.pageable.page_size,
          pageNumber: res.pageable.page_number,
          offset: res.pageable.offset,
          paged: res.pageable.paged,
          unpaged: res.pageable.unpaged,
        },
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,
      };
    case SUCCESS(ACTION_TYPES.FETCH_ASSIGNMENT):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_ASSIGNMENT):
    case SUCCESS(ACTION_TYPES.UPDATE_ASSIGNMENT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
        successMessage: action.payload.meta,
      };
    case SUCCESS(ACTION_TYPES.DELETE_ASSIGNMENT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default assignmentReducer;

// ACTIONS
export const getEntities = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_ASSIGNMENT_LIST,
  payload: axios.get(apiUrl, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntitiesCondition = (condition, page, sort) => ({
  type: ACTION_TYPES.FETCH_ASSIGNMENT_LIST,
  payload: axios.get(`${apiUrl}/search?q=${condition}`, {
    params: {
      page: undefined || page,
      sort: undefined || sort
    },
  })
});

export const getEntity = id => ({
  type: ACTION_TYPES.FETCH_ASSIGNMENT,
  payload: axios.get(`${apiUrl}/${id}`),
});

export const createEntity = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_ASSIGNMENT,
    payload: axios.post(apiUrl, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  return result;
};

export const updateEntity = (entity, id) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_ASSIGNMENT,
    payload: axios.patch(`${apiUrl}/${id}`, entity),
    meta: { successMessage: `Berhasil update!` },
  });
  return result;
};

export const deleteEntity = (id, pencarian, condition, pagination, sortTable) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_ASSIGNMENT,
    payload: axios.delete(`${apiUrl}/${id}`),
    meta: { successMessage: `Berhasil hapus!` },
  });
  if(pencarian === true){
    let condition2 = "name:"+condition;
    dispatch(getEntitiesCondition(condition2, pagination.current-1, sortTable));
  }else{
    dispatch(getEntities(pagination.current-1, null, sortTable));
  }
  
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
